import React from "react";
import Button from "../../../Elements/Button/Button";
import useIsMobile from "../../../../Hooks/useIsMobile";

const WorkWithUs = () => {
    const isMobile = useIsMobile();

    const bgImage = isMobile
        ? "/assets/imgs/Backgroundmob.png"
        : "/assets/imgs/Backgroundprincipal-pc.png";

    return (
        <section
            className="login-bg d-flex align-items-center min-vh-100"
            style={{
                backgroundImage: `url(${bgImage})`,
                backgroundPosition: "center",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                width: "100%",
                height: "100%",
            }}
        >
            <div className="container py-5">
                <div className="row justify-content-center">
                    <div className="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5">
                        <div className="card glass border-0 shadow-lg overflow-hidden">
                            <div className="card-body p-4 p-md-5 text-center">

                                <img
                                    src="/assets/imgs/Sin fondo.png"
                                    alt="BubUp"
                                    className="login-logo mb-3"
                                />

                                <h4 className="fw-bold text-white mb-2">
                                    ¡Únete a BubUp! 🚀
                                </h4>

                                <p className="text-white-50 mb-4">
                                    Escoge cómo quieres trabajar con nosotros
                                </p>

                                <div className="d-grid gap-3">
                                    <Button
                                        text="Regístrate como Comerciante"
                                        color="blue"
                                        fill
                                        action={() =>
                                        (window.location.href =
                                            "/register?role=comerciante")
                                        }
                                        classNames="w-100 py-3"
                                    />

                                    <Button
                                        text="Regístrate como Repartidor"
                                        color="green"
                                        fill
                                        action={() =>
                                        (window.location.href =
                                            "/register?role=repartidor")
                                        }
                                        classNames="w-100 py-3"
                                    />
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default WorkWithUs;